<div class="request__interface__input">
    <ng-container [ngTemplateOutlet]="showLoadingSave && {
      'loader': loaderTemplate,
      'success': successTemplate,
      'error': errorTemplate,
      'action': actionTemplate
    }[modalTemplate]"></ng-container>
</div>

<ng-template #actionTemplate>
  <ng-content></ng-content>
</ng-template>
<ng-template #loaderTemplate>
  <app-loader
    [color]="corporativeColor"
    [size]="sizeLoader">
  </app-loader>
</ng-template>
<ng-template #successTemplate>
  <div [@bounceAnimation]>
    <div class="request__interface__input__message">
      <div class="request__interface__input__message--arrow"></div>
      {{ tooltipSaveSuccess }}
    </div>
    <i class="avc-check-circle request__interface__input__success"></i>
  </div>
</ng-template>
<ng-template #errorTemplate>
  <div [@bounceAnimation]>
    <div class="request__interface__input__message">
      <div class="request__interface__input__message--arrow"></div>
      <span>{{ tooltipSaveError }}</span>
    </div>
    <i class="avc-cross-circle request__interface__input__error"></i>
  </div>
</ng-template>

